import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import ProLayout from '@ant-design/pro-layout';
import { Link } from 'react-router-dom';
import { Suspense } from 'react';
import { onGetRouteList } from '@/api/services/route';
import { RouteLoading } from '../pages.router';


const WelcomeRoutes = () => {
  const navigation = useNavigate()
  const { pathname } = useLocation()

  return (
    <div
      style={{
        height: '100vh'
      }}
    >
      <ProLayout
        route={{
          path: '/'
        }}
        title="My Tools"
        colorPrimary='#1890ff'
        location={{ pathname }}
        token={{
          header: {
            colorBgMenuItemSelected: 'rgba(0,0,0,0.04)',
          },
        }}
        siderMenuType="sub"
        menu={{
          type: 'group',
          collapsedShowGroupTitle: false,
          request: async () => {
            return (await onGetRouteList()).payload
          }
        }}
        menuItemRender={(item, dom) => (
          <Link to={item.path!}>
            {dom}
          </Link>
        )}
        avatarProps={{
          src: 'https://gw.alipayobjects.com/zos/antfincdn/efFD%24IOql2/weixintupian_20170331104822.jpg',
          title: 'Sven',
          onClick: () => {
            navigation(`info`)
          }
        }}
        
      >
        <Suspense fallback={<RouteLoading />}>
          <Outlet />
        </Suspense>
      </ProLayout>
    </div>
  )
}

export default WelcomeRoutes
